$(document).ready(function() {

  function updatePlanInfo() {
    var selectedElementData = document.querySelector("input[name=plan]:checked").dataset;
    var planPriceElement = document.getElementsByClassName("plan-price")[0];
    var planDurationElement = document.getElementsByClassName("plan-duration-string")[0];

    var price = selectedElementData.priceInKroner;
    var duration = selectedElementData.durationString;

    planPriceElement.textContent = price;
    planDurationElement.textContent = duration;
  }

  function showPlanSelector() {
    var planSelector = document.getElementById('plan-selector');
    var planToggler = document.getElementById('plan-selector-toggler');

    planToggler.classList.add('hidden');
    planSelector.classList.remove('hidden');
  }

  function setupPlanSelectorTogglerListeners() {
    document.getElementById('plan-selector-toggler').addEventListener("click", function(event) {
      showPlanSelector();
      event.preventDefault();
    });

    document.getElementById('plan-selector-toggler').addEventListener('keypress', function (event) {
      if (event.key === 'Enter') {
        showPlanSelector();
      }
    });
  }

  function setupPlanSelectorListenerForABTest() {
    document.getElementById('plan-selector2').addEventListener("change", function(_event) {
      togglePlanSelectorForABTest();
    });

    document.getElementById('plan-selector-toggler2').addEventListener("click", function(event) {
      togglePlanSelectorForABTest();
      event.preventDefault();
    });
  }

  function togglePlanSelectorForABTest() {
    var planSelector = document.getElementById('plan-selector2');
    planSelector.classList.toggle('user-select-mode');
  }

  function setupPlanSelectorListener() {
    var elements = document.querySelectorAll('input[name="plan"]')
    for (var i=0; i < elements.length; i++) {
      elements[i].addEventListener("change", function(_event) {
        updatePlanInfo();
      });
    }
  }

  function isAlternativeLayout() {
    return $('.service-bundling-payment-wrapper .plan-selection2').length > 0;
  }

  if (isAlternativeLayout()) {
    // For A/B testing
    setupPlanSelectorListenerForABTest();
  } else {
    updatePlanInfo(); // Make sure price information matches plan selection on load.

    setupPlanSelectorListener();
    setupPlanSelectorTogglerListeners();
  }
});
